import { IChatDashboardSettings } from '../types';
import { AT_UPDATE, IUpdateAction } from './types';

export const updateAction = (
    chatDashboardSettings: IChatDashboardSettings
): IUpdateAction => {
    return {
        type: AT_UPDATE,
        chatDashboardSettings
    }
};
